'use client';

import { ENABLE_EARLY_BUILDER_OPEN_FEATURE_FLAG } from '@lib/flows/constants/early-builder-open-feature-flag';
import { useIsFeatureEnabled } from '@lib/observability/feature-flags/use-is-feature-enabled';

/** True when early builder navigation on upload is enabled for the current user. */
export function useIsEarlyBuilderOpenEnabled() {
  return useIsFeatureEnabled(ENABLE_EARLY_BUILDER_OPEN_FEATURE_FLAG);
}